import React, { useEffect, useRef, useState } from "react";
import {
  FlatList,
  Image as RNImage,
  StyleSheet,
  Text as RNText,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import {
  Box,
  Flex,
  Image,
  Text,
  useColorMode,
  useColorModeValue,
  useToast,
} from "native-base";
import { RFPercentage } from "react-native-responsive-fontsize";
import Input from "../../../../components/Input";
import { useNavigation, useRoute } from "@react-navigation/native";
import Api from "../../../../Api/Api";
import Template from "../../../template/Index";
import styles from "./styles";
import { useTheme } from "../../../../ThemeProvider";
import SkeletonItens from "../../../components/Skeleton/Itens";
import StorageUtil from "../../../../Utils";
import ModalConfirmacao from "../../../../components/ModalConfirmacao";
import { Feather, MaterialCommunityIcons } from "@expo/vector-icons";
import { useToastMessage } from "../../../hooks/useToastMessage";
import TemplateEtapas from "../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../template/Etapas/styles";
import { corComAlpha, corTextoSobre } from "../../../theme/cores";

export default function Servicos() {
  const {
    primaryColor,
    cor_rgba,
    isMobile,
    brindeAniversarianteMes,
    mesAtual,
    getCodEmpresa,
    configEmpresa,
  } = useTheme();

  const toast = useToast();
  const navigation = useNavigation();
  type RouteParams = {
    params: any;
    servicos_adicionais?: boolean;
    hideMessageAlerta?: boolean;
  };

  type itensPrametors = {
    item: any;
    index: number;
  };

  const route = useRoute<RouteParams>();
  const refModal = useRef<any>(null);
  const confirmationRef = useRef<any>(null);
  const confirmationRemoverBrindeRef = useRef<any>(null);

  const [servicos_selecionados, setServicosSelecionados] = useState<any[]>([]);
  const [filtro, setFiltro] = useState<String>("");
  const [servicos, setServicos] = useState<any[]>([{}, {}, {}]);
  const [servicos_original, setServicosOriginal] = useState<any[]>([]);
  const [buscando, setBuscando] = useState<Boolean>(true);
  const [servicoBrindeSelecionar, setServicoBrindeSelecionar] = useState<any[]>(
    [],
  );
  const [exibeBrinde, setExibeBrinde] = useState<boolean>(false);
  const [brindeRemover, setBrindeRemover] = useState<any>({});

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa),
  );

  const { error } = useToastMessage();

  const { colorMode } = useColorMode();

  useEffect(() => {
    if (brindeAniversarianteMes && !getConfigEmpresa.utilizaPwaSimples) {
      validaServicoBrinde();
    }

    getServicos();
  }, []);

  async function validaServicoBrinde() {
    let peloMenosUmBrinde =
      route.params?.profissional_selecionado?.servicos.find(
        (item: any) => item.brindeAniversario,
      );

    if (!peloMenosUmBrinde) {
      return;
    }

    const value: { id: number; dtNascimento: string } | null =
      await StorageUtil.getItem("cliente");

    if (value && value.id > 0) {
      const extraiMes = new Date(value.dtNascimento).getMonth() + 1;

      if (mesAtual == extraiMes) {
        const servicoBrinde = await Api.buscaUtilizacaoServicoBrinde(
          value.id,
          getCodEmpresa,
        );

        if (servicoBrinde.status && servicoBrinde.data.length > 0) {
          setServicoBrindeSelecionar(servicoBrinde.data);
          confirmationRef.current.abrirModal();
        }
      }
    }
  }

  //OBS: aqui tem 2 regras para busca de serviço, 1 pega do serviços relacionados do cliente 2 pega direto da tab_serviços
  async function getServicos() {
    setBuscando(true);

    let serv = [];

    if (getConfigEmpresa.utilizaPwaSimples || getConfigEmpresa.versaoPWA == 2) {
      const ret = await Api.servicos(getCodEmpresa);
      serv = ret.data;
    } else {
      serv = route.params?.profissional_selecionado?.servicos;
    }

    serv.map((item: any) => {
      item.selecionado = false;
    });

    const ordenado = serv.sort((a, b) => {
      if (a.brindeAniversario && !b.brindeAniversario) {
        return -1;
      }
      if (!a.brindeAniversario && b.brindeAniversario) {
        return 1;
      }
      return (b.prioridadeExibicao ?? 0) - (a.prioridadeExibicao ?? 0);
    });
    setServicos(ordenado);
    setServicosOriginal(ordenado);
    setServicosSelecionados([]);

    setBuscando(false);
  }

  function onPressItemSelecionado(item: any, ignoraBrinde: boolean = false) {
    const servico_copy = [...servicos_selecionados];
    const servicos_copy = [...servicos];

    if (item.brindeAniversario && !ignoraBrinde) {
      const index = servico_copy.findIndex(
        (item_servico) => item_servico.id === item.id,
      );

      if (index > -1) {
        setBrindeRemover(item);
        confirmationRemoverBrindeRef.current.abrirModal();
        return;
      }
    }

    const index = servico_copy.findIndex(
      (item_servico) => item_servico.id === item.id,
    );

    if (index === -1) {
      servico_copy.push(item);

      const index_servico = servicos_copy.findIndex(
        (item_servico) => item_servico.id === item.id,
      );
      servicos_copy[index_servico].selecionado = true;
    } else {
      servico_copy.splice(index, 1);
      const index_servico = servicos_copy.findIndex(
        (item_servico) => item_servico.id === item.id,
      );
      servicos_copy[index_servico].selecionado = false;
    }

    setServicosSelecionados(servico_copy);
    setServicos(servicos_copy);
  }

  function linhaServico(item: any) {
    return getConfigEmpresa.utilizaPwaSimples ||
      getConfigEmpresa.exibeTempoServicoPWA ? (
      <Flex style={[styles.containerFlex, {}]}>
        {isMobile && (
          <Image
            source={
              item.foto == null
                ? require("../../../img/corte-de-cabelo.png")
                : {
                    uri: item.foto?.url,
                  }
            }
            alt="Avatar"
            resizeMode="cover"
            style={styles.imageItem}
          />
        )}

        <Box
          style={{
            width: "75%",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <Text
            style={[
              styles.itemTextWithMargin,
              {
                color: item.selecionado
                  ? "black"
                  : getConfigEmpresa.coresPWA.corFontePrimaria,
                fontWeight: "500",
              },
            ]}
            fontSize="md"
          >
            {item.nome}
          </Text>

          {item.brindeAniversario && (
            <Text
              style={[
                styles.itemTextWithMarginBrinde,
                {
                  color: item.selecionado
                    ? "black"
                    : getConfigEmpresa.coresPWA.corFontePrimaria,
                },
              ]}
              fontSize="sm"
            >
              {item.descricao}
            </Text>
          )}

          <Text
            style={[
              styles.itemText,
              {
                marginLeft: 10,
                marginTop: 7,
                color: item.selecionado
                  ? "black"
                  : getConfigEmpresa.coresPWA.corFontePrimaria,
              },
            ]}
            fontSize="md"
          >
            <MaterialCommunityIcons
              name="cash-multiple"
              size={16}
              color={
                item.selecionado
                  ? "black"
                  : getConfigEmpresa.coresPWA.corFontePrimaria
              }
            />{" "}
            {`R$ ${item.valor}`} -{" "}
            <MaterialCommunityIcons
              name="clock-outline"
              size={16}
              color={
                item.selecionado
                  ? "black"
                  : getConfigEmpresa.coresPWA.corFontePrimaria
              }
            />{" "}
            {`${item.tempo} Min`}
          </Text>
        </Box>
      </Flex>
    ) : (
      <Flex style={styles.containerFlex}>
        <Box style={styles.leftFlex}>
          {isMobile && (
            <Image
              source={
                item.foto == null
                  ? require("../../../img/corte-de-cabelo.png")
                  : {
                      uri: item.foto?.url,
                    }
              }
              alt="Avatar"
              resizeMode="cover"
              style={styles.imageItem}
            />
          )}

          <Box
            style={{
              flex: 1,
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Text
              style={[
                styles.itemTextWithMargin,
                {
                  color: item.selecionado
                    ? "black"
                    : getConfigEmpresa.coresPWA.corFontePrimaria,
                  fontWeight: "500",
                },
              ]}
              fontSize="md"
            >
              {item.nome}
            </Text>
            {item.brindeAniversario && (
              <Text
                style={[
                  styles.itemTextWithMarginBrinde,
                  {
                    color: item.selecionado
                      ? "black"
                      : getConfigEmpresa.coresPWA.corFontePrimaria,
                  },
                ]}
                fontSize="sm"
              >
                {item.descricao}
              </Text>
            )}
            {
              <Text
                style={[
                  {
                    marginLeft: 10,
                    color: item.selecionado
                      ? "black"
                      : //colocar cor mais clara do que a cor de fonte primária para diferenciar o texto do brinde da descrição do serviço
                        getConfigEmpresa.coresPWA.corFontePrimaria + "99",
                  },
                ]}
                fontSize="xs"
              >
                {item.descricao}
              </Text>
            }
          </Box>
        </Box>

        <Flex style={[styles.rightFlex, {}]}>
          <Text
            style={[
              styles.itemText,
              {
                color: item.selecionado
                  ? "black"
                  : getConfigEmpresa.coresPWA.corFontePrimaria,
                fontWeight: "500",
              },
            ]}
            fontSize="sm"
          >
            <MaterialCommunityIcons
              name="cash-multiple"
              size={16}
              color={
                item.selecionado
                  ? "black"
                  : getConfigEmpresa.coresPWA.corFontePrimaria
              }
            />{" "}
            {`R$ ${item.valor}`}
          </Text>
        </Flex>
      </Flex>
    );
  }

  function filtrarServicos(text: string) {
    setFiltro(text);
    const servicos_copy = [...servicos_original];
    const servicos_filtrados = servicos_copy.filter((item) => {
      return item.nome.toUpperCase().includes(text.toUpperCase());
    });
    setServicos(servicos_filtrados);
  }

  function renderFiltro() {
    return (
      <Input
        type={"text"}
        icon={"search"}
        value={String(filtro || "")}
        width={"100%"}
        colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
        corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
        onChangeText={filtrarServicos}
        placeholder="Serviço"
        helperText="Informe o nome do serviço"
      />
    );
  }

  function renderItem({ item, index }: itensPrametors) {
    if (item.brindeAniversario && !exibeBrinde) {
      return null;
    }

    return (
      <TouchableOpacity
        key={index}
        style={[
          styles.pressableItem,
          {
            borderColor: getConfigEmpresa.coresPWA.corBordaItens,
            // { borderColor: item.selecionado ? 'red' : 'rgba(0, 0, 0, 0.2)',
            // { borderColor: item.selecionado ? cor_rgba ?? 'defaultColor' : 'rgba(0, 0, 0, 0.2)',
            backgroundColor: item.selecionado ? "#ECFFDC" : "" + colorMode,
          }, //mais clara
        ]}
        onPress={() => onPressItemSelecionado(item)}
      >
        {buscando ? <SkeletonItens /> : linhaServico(item)}
      </TouchableOpacity>
    );
  }

  const renderEmptyComponent = () => (
    <Box alignItems="center" justifyContent="center" mt={5}>
      <MaterialCommunityIcons
        name="database-remove"
        size={80}
        color={getConfigEmpresa.coresPWA.corFontePrimaria}
        style={{ marginBottom: 10 }}
      />
      <Text
        style={{
          textAlign: "center",
          fontSize: RFPercentage(2.5),
          color: getConfigEmpresa.coresPWA.corFontePrimaria,
        }}
      >
        Nenhum registro encontrado.
      </Text>
    </Box>
  );

  const validaTotalServico = (servicos_selecionados: any[]) => {
    let total = 0;
    servicos_selecionados.map((item) => {
      total += parseFloat(item.valor);
    });

    return total.toFixed(2);
  };

  function confirmarRemoverBrinde() {
    onPressItemSelecionado(brindeRemover, true);
    confirmationRemoverBrindeRef.current.fecharModal();
  }

  function confirmarUtilizacaoBrinde() {
    setExibeBrinde(true);

    for (const brinde of servicoBrindeSelecionar) {
      const encontraBrinde = servicos.find((item) => item.id === brinde.id);

      if (encontraBrinde) {
        onPressItemSelecionado(encontraBrinde);
      }
    }
    confirmationRef.current.fecharModal();
  }

  const exibeLogo =
    !route.params?.servicos_adicionais &&
    (getConfigEmpresa?.utilizaPwaSimples || getConfigEmpresa?.versaoPWA == 2);

  function avancar() {
    if (
      servicos_selecionados.length == 0 &&
      !route.params?.servicos_adicionais
    ) {
      error("Atenção", "Selecione pelo menos um serviço!");
      return;
    }

    if (route.params?.servicos_adicionais) {
      navigation.navigate("Data", {
        servicos_selecionados: servicos_selecionados,
        ...route.params,
      });
      return;
    }

    if (
      getConfigEmpresa?.utilizaPwaSimples ||
      getConfigEmpresa?.versaoPWA == 2
    ) {
      navigation.navigate("Profissional", {
        servicos_selecionados: servicos_selecionados,
        ...route.params,
      });
      return;
    }

    navigation.navigate("Data", {
      servicos_selecionados: servicos_selecionados,
      ...route.params,
    });
  }

  function renderModaisBrinde() {
    return (
      <>
        <ModalConfirmacao
          ref={confirmationRef}
          titulo={"Atenção"}
          mensagem={
            "Você tem direito a um brinde no mês do seu aniversário, deseja utilizá-lo?"
          }
          textoBotaoNegativo={"Não Utilizar"}
          textoBotaoPositivo={"Utilizar"}
          onConfirmNegativo={() => confirmationRef.current.fecharModal()}
          onConfirmPositivo={() => confirmarUtilizacaoBrinde()}
        />

        <ModalConfirmacao
          ref={confirmationRemoverBrindeRef}
          titulo={"Atenção"}
          mensagem={"Tem certeza que deseja remover esse brinde ?"}
          textoBotaoNegativo={"Cancelar"}
          textoBotaoPositivo={"Confirmar"}
          onConfirmNegativo={() =>
            confirmationRemoverBrindeRef.current.fecharModal()
          }
          onConfirmPositivo={() => confirmarRemoverBrinde()}
        />
      </>
    );
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  function formatarValor(valor: any) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function renderBuscaNova() {
    return (
      <View style={[stylesNovo.busca, sombraCard]}>
        <Feather name="search" size={17} color={CORES.subtitulo} />
        <TextInput
          value={String(filtro || "")}
          onChangeText={filtrarServicos}
          placeholder="Buscar serviço"
          placeholderTextColor={CORES.subtitulo}
          style={stylesNovo.inputBusca as any}
        />
      </View>
    );
  }

  function renderCardServico(item: any, index: number) {
    if (item.brindeAniversario && !exibeBrinde) {
      return null;
    }

    const selecionado = !!item.selecionado;

    return (
      <TouchableOpacity
        key={item.id ?? index}
        activeOpacity={0.85}
        onPress={() => onPressItemSelecionado(item)}
        style={[
          stylesNovo.card,
          sombraCard,
          selecionado && {
            borderColor: corPrincipal,
            backgroundColor: corComAlpha(corPrincipal, 0.06),
          },
        ]}
      >
        <View
          style={[
            stylesNovo.icone,
            { backgroundColor: corComAlpha(corPrincipal, 0.1) },
          ]}
        >
          {item.foto?.url ? (
            <RNImage
              source={{ uri: item.foto.url }}
              style={stylesNovo.foto}
              resizeMode="cover"
            />
          ) : (
            <Feather name="scissors" size={20} color={corPrincipal} />
          )}
        </View>

        <View style={{ flex: 1 }}>
          <RNText style={stylesNovo.nome} numberOfLines={2}>
            {item.nome}
          </RNText>

          {item.brindeAniversario && (
            <View style={stylesNovo.badgeBrinde}>
              <Feather name="gift" size={11} color="#9a6b12" />
              <RNText style={stylesNovo.textoBadgeBrinde}>
                Brinde de aniversário
              </RNText>
            </View>
          )}

          {!!item.descricao && (
            <RNText style={stylesNovo.descricao} numberOfLines={2}>
              {item.descricao}
            </RNText>
          )}

          {getConfigEmpresa.exibeTempoServicoPWA && !!item.tempo && (
            <View style={stylesNovo.linhaTempo}>
              <Feather name="clock" size={11} color={CORES.subtitulo} />
              <RNText style={stylesNovo.descricao}>{item.tempo} min</RNText>
            </View>
          )}
        </View>

        <RNText style={stylesNovo.valor}>{formatarValor(item.valor)}</RNText>

        <View
          style={[
            stylesNovo.checkbox,
            selecionado && {
              backgroundColor: corPrincipal,
              borderColor: corPrincipal,
            },
          ]}
        >
          {selecionado && (
            <Feather name="check" size={14} color={corTextoPrincipal} />
          )}
        </View>
      </TouchableOpacity>
    );
  }

  if (!utilizaLayoutLegado) {
    const quantidade = servicos_selecionados.length;
    const servicosAdicionais = !!route.params?.servicos_adicionais;

    return (
      <TemplateEtapas
        ref={refModal}
        etapaAtual={2}
        totalEtapas={5}
        rotuloEtapa={servicosAdicionais ? "Serviços adicionais" : undefined}
        titulo={
          servicosAdicionais
            ? "Quer adicionar\nalgo a mais?"
            : "O que vamos\nfazer hoje?"
        }
        subtitulo="Você pode escolher mais de um serviço."
        filtro={renderBuscaNova()}
        ocultarRodape={getConfigEmpresa?.ocultaBotoesRodapeServicos}
        resumoRotulo={
          quantidade > 0
            ? `${quantidade} ${quantidade === 1 ? "serviço" : "serviços"}`
            : "Nenhum serviço"
        }
        resumoValor={formatarValor(validaTotalServico(servicos_selecionados))}
        desabilitarBotao={quantidade === 0 && !servicosAdicionais}
        onBotaoClick={avancar}
      >
        {buscando ? (
          <SkeletonItens />
        ) : servicos.length === 0 ? (
          <View style={stylesNovo.vazio}>
            <Feather name="scissors" size={40} color={CORES.subtitulo} />
            <RNText style={stylesNovo.textoVazio}>
              Nenhum serviço encontrado.
            </RNText>
          </View>
        ) : (
          servicos.map((item, index) => renderCardServico(item, index))
        )}

        {renderModaisBrinde()}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={
        route.params?.servicos_adicionais
          ? "Serviços Adicionais"
          : "Selecione os Serviços"
      }
      messageAlerta={
        route.params?.hideMessageAlerta
          ? ""
          : "Por gentileza, selecione o(s) serviço(s) que deseja realizar"
      }
      exibeLogo={exibeLogo}
      ocultarBotaoCancelar={exibeLogo}
      exibeMenuSuperior={getConfigEmpresa?.exibeMenuSuperiorPWA}
      // urlLogo={'https://i.ibb.co/jzhMQTL/download-1.jpg'}
      urlLogo={route.params?.logo}
      // urlLogo={route.params?.logo}
      textoCentroFooter={"R$ " + validaTotalServico(servicos_selecionados)}
      semBotaoProximo={getConfigEmpresa?.ocultaBotoesRodapeServicos}
      semBotaoVoltar={getConfigEmpresa?.ocultaBotoesRodapeServicos}
      titulo_botao_voltar={
        getConfigEmpresa?.utilizaPwaSimples || getConfigEmpresa?.versaoPWA == 2
          ? "Logar"
          : "Voltar"
      }
      icon_voltar={
        getConfigEmpresa?.utilizaPwaSimples || getConfigEmpresa?.versaoPWA == 2
          ? "lock-open"
          : "arrow-with-circle-left"
      }
      onBotaoProximoClick={avancar}
      onBotaoVoltarClick={() => {
        if (
          getConfigEmpresa?.utilizaPwaSimples ||
          getConfigEmpresa?.versaoPWA == 2
        ) {
          navigation.navigate("TabNavigator", {
            screen: "Login",
          });
        } else {
          navigation.goBack();
        }
      }}
      filtro={renderFiltro()}
      ref={refModal}
    >
      <Box style={styles.mainContainer}>
        <FlatList
          data={servicos}
          renderItem={renderItem}
          ListEmptyComponent={
            buscando ? <SkeletonItens /> : renderEmptyComponent
          }
          keyExtractor={(item, index) => index.toString()}
          contentContainerStyle={{
            width: wp("98%"),
          }}
        />
      </Box>

      {renderModaisBrinde()}
    </Template>
  );
}

const stylesNovo = StyleSheet.create({
  busca: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    height: 48,
    paddingHorizontal: 14,
    borderRadius: 14,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  inputBusca: {
    flex: 1,
    height: "100%",
    fontSize: 15,
    color: CORES.titulo,
    outlineStyle: "none",
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    padding: 14,
    marginBottom: 12,
    borderRadius: 18,
    backgroundColor: CORES.card,
    borderWidth: 1.5,
    borderColor: "transparent",
  },
  icone: {
    width: 48,
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  foto: {
    width: "100%",
    height: "100%",
  },
  nome: {
    fontSize: 15,
    fontWeight: "700",
    color: CORES.titulo,
  },
  descricao: {
    fontSize: 12,
    color: CORES.subtitulo,
    marginTop: 2,
  },
  linhaTempo: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  badgeBrinde: {
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    marginTop: 4,
    paddingVertical: 2,
    paddingHorizontal: 8,
    borderRadius: 10,
    backgroundColor: "#FBEFD5",
  },
  textoBadgeBrinde: {
    fontSize: 11,
    fontWeight: "700",
    color: "#9a6b12",
  },
  valor: {
    fontSize: 14,
    fontWeight: "700",
    color: CORES.titulo,
  },
  checkbox: {
    width: 22,
    height: 22,
    borderRadius: 6,
    borderWidth: 1.5,
    borderColor: "#cfcfcf",
    alignItems: "center",
    justifyContent: "center",
  },
  vazio: {
    alignItems: "center",
    paddingVertical: 40,
    gap: 12,
  },
  textoVazio: {
    fontSize: 15,
    color: CORES.subtitulo,
  },
});
